// Matomo Analytics – only run on production domain

document.addEventListener('DOMContentLoaded', function() {
  const host = window.location.hostname;

  // Only initialize Matomo on hoppalaapp.at (and any subpaths)
  if (host === 'hoppalaapp.at' || host === 'www.hoppalaapp.at') {
    var _paq = window._paq = window._paq || [];

    _paq.push(['disableCookies']);                      // No cookies used
    _paq.push(['disableBrowserFeatureDetection']);      // Avoid fingerprinting
    _paq.push(['trackPageView']);                       // Track initial page view
    _paq.push(['enableLinkTracking']);                  // Enable link click tracking

    (function() {
      var u = 'https://analytics.kfv.at/';       // Matomo server URL

      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '59']);                   // Matomo site ID

      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];

      g.async = true;
      g.src = u + 'matomo.js';
      s.parentNode.insertBefore(g, s);
    })();
  }
});
